import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import DashboardHeader from '../../components/dasboardHeader/index.vue'
import SideNav from '../../components/sideNavBar/index.vue'
import PostJobModal from '../../components/PostJobModal/index.vue'
// import GuestService from '../../services/GuestService'
import UserService from '../../services/UserService'
import { showSuccessToast, showErrorToast } from '../../services/UI'
// import Shepherd from 'shepherd.js'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      // userOnBoardingStatus: false,
      Consecutive: false,
      nonConsecutive: false,
      modalActive: false,
      professions: [],
      qualifications: [],
      departments: [],
      specialisations: [],
      shifts: [],
      experiences: [],
      branches: [],

      profession: '',
      specialisation: '',
      qualification: '',
      experience: '',
      branch: '',
      department: '',
      shift: '',
      minJobRate: 'Fill above fields',
      applicants: '',
      maxRate: '',
      JD: '',
      toApprove: true,
      approvalHospital: '',

      shiftCost: '?',
      totalCost: '?',
      marginCost: '?',
      tax: '?',
      total: '?',
      days: 'Fill above fields',
      totalCostNurse: '?',
      messages: [
        {
          title: 'Su',
          active: false,
          value: 'SUNDAY',
          day: 0
        },
        {
          title: 'M',
          active: false,
          value: 'MONDAY',
          day: 1
        },
        {
          title: 'Tu',
          active: false,
          value: 'TUESDAY',
          day: 2
        },
        {
          title: 'W',
          active: false,
          value: 'WEDNESDAY',
          day: 3
        },
        {
          title: 'Th',
          active: false,
          value: 'THURSDAY',
          day: 4
        },
        {
          title: 'F',
          active: false,
          value: 'FRIDAY',
          day: 5
        },
        {
          title: 'Sa',
          active: false,
          value: 'SATURDAY',
          day: 6
        }
      ],
      startDate: new Date(),
      endDate: '',
      checkbox1: false,
      checkbox2: false,
      checkbox3: false,
      orgUsers: [],
      selected: '',
      filteredUser: ''
    }
  },
  components: {
    DashboardHeader,
    SideNav,
    PostJobModal
  },
  mounted () {
    // window.analytics.page('miniJob')
    window.analytics.identify('miniJob', {
      path: '/miniJob'
    })
  //   const tour = new Shepherd.Tour({
  //     defaultStepOptions: {
  //       cancelIcon: {
  //         enabled: false
  //       },
  //       scrollTo: {
  //         behavior: 'smooth',
  //         block: 'center'
  //       },
  //       arrow: false,
  //       modalOverlayOpeningPadding: 20
  //     },
  //     useModalOverlay: true
  //   })
  //   tour.addStep({
  //     attachTo: { element: '.step3', on: 'bottom' },
  //     text: 'Select Location where you want to hire',
  //     buttons: [
  //       {
  //         text: 'Skip',
  //         action () {
  //           localStorage.setItem('tourToken', JSON.stringify({
  //             userOnBoardingStatus: 'yes'
  //           }))
  //           location.reload()
  //           // window.location.href = '/#/dashboard'
  //         }
  //       },
  //       {
  //         text: '<< Back',
  //         action () {
  //           return this.back()
  //         }
  //       },
  //       {
  //         text: 'Next >>',
  //         action () {
  //           return this.next()
  //         }
  //       }
  //     ]
  //   })
  //   tour.addStep({
  //     attachTo: { element: '.step4', on: 'bottom' },
  //     text: 'Select profession which are required',
  //     buttons: [
  //       {
  //         text: 'Skip',
  //         action () {
  //           localStorage.setItem('tourToken', JSON.stringify({
  //             userOnBoardingStatus: 'yes'
  //           }))
  //           location.reload()
  //           // window.location.href = '/#/dashboard'
  //         }
  //       },
  //       {
  //         text: '<< Back',
  //         action () {
  //           return this.back()
  //         }
  //       },
  //       {
  //         text: 'Next >>',
  //         action () {
  //           tour.next()
  //         }
  //       }
  //     ],
  //     scrollTo: true
  //   })
  //   tour.addStep({
  //     attachTo: { element: '.step5', on: 'bottom' },
  //     text: 'Select Timings for the job',
  //     buttons: [
  //       {
  //         text: 'Skip',
  //         action () {
  //           localStorage.setItem('tourToken', JSON.stringify({
  //             userOnBoardingStatus: 'yes'
  //           }))
  //           location.reload()
  //           // window.location.href = '/#/dashboard'
  //         }
  //       },
  //       {
  //         text: '<< Back',
  //         action () {
  //           return this.back()
  //         }
  //       },
  //       {
  //         text: 'Next >>',
  //         action () {
  //           tour.next()
  //         }
  //       }
  //     ]
  //   })
  //   tour.addStep({
  //     attachTo: { element: '.step6', on: 'bottom' },
  //     text: 'Here you can offered rate per hour to the professionals',
  //     buttons: [
  //       {
  //         text: 'Skip',
  //         action () {
  //           localStorage.setItem('tourToken', JSON.stringify({
  //             userOnBoardingStatus: 'yes'
  //           }))
  //           location.reload()
  //           // window.location.href = '/#/dashboard'
  //         }
  //       },
  //       {
  //         text: '<< Back',
  //         action () {
  //           return this.back()
  //         }
  //       },
  //       {
  //         text: 'Next >>',
  //         action () {
  //           tour.next()
  //         }
  //       }
  //     ]
  //   })
  //   tour.addStep({
  //     attachTo: { element: '.step7', on: 'bottom' },
  //     text: 'Here you can post a job',
  //     buttons: [
  //       {
  //         text: 'Skip',
  //         action () {
  //           localStorage.setItem('tourToken', JSON.stringify({
  //             userOnBoardingStatus: 'yes'
  //           }))
  //           location.reload()
  //           // window.location.href = '/#/dashboard'
  //         }
  //       },
  //       {
  //         text: '<< Back',
  //         action () {
  //           return this.back()
  //         }
  //       },
  //       {
  //         scrollTo: true,
  //         text: 'Next >>',
  //         action () {
  //           window.location.href = '/#/open_jobs'
  //           // write backend code to send user onBoarding status true here
  //           tour.next()
  //         }
  //       }
  //     ]
  //   })
  //   if (JSON.parse(localStorage.getItem('tourToken')).userOnBoardingStatus === 'no') {
  //     tour.start()
  //   }
  },
  async created () {
    // this.professions = await GuestService.listProfessions()
    // this.qualifications = await GuestService.listQualifications()
    // this.experiences = await GuestService.listExperiences()
    // this.specialisations = await GuestService.listSpecialisations()
    // this.shifts = await GuestService.getEnum('EnumShiftType')
    this.branches = await UserService.listMiniJobBranches()
    this.orgUsers = await UserService.orgUsers()
  },
  computed: {
    messagesLength: function () {
      return this.messages.length
    },

    activeMessages: function () {
      let actives = 0
      this.messages.forEach(function (message, index) {
        // eslint-disable-next-line eqeqeq
        if (message.active == true) {
          actives++
        }
      })

      return actives
    },

    inactiveMessages: function () {
      let inactives = 0
      this.messages.forEach(function (message, index) {
        // eslint-disable-next-line eqeqeq
        if (message.active == false) {
          inactives++
        }
      })

      return inactives
    }
  },
  methods: {
    handleBackEvent () {
      this.$router.go(-1)
    },
    // addMessage: function (sentMessage) {
    //   const scopedMessage = {}
    //   for (const key in sentMessage) {
    //     // eslint-disable-next-line no-prototype-builtins,eqeqeq
    //     if (!this.newMessage.hasOwnProperty(key) || this.newMessage[key] == '') {
    //       console.log('No property for ' + key)
    //       return false
    //     }

    //     scopedMessage[key] = this.newMessage[key]
    //   }

    //   this.messages.push(scopedMessage)

    //   for (const key in this.newMessage) {
    //     this.newMessage[key] = ''

    //     // eslint-disable-next-line eqeqeq
    //     if (key == 'active') {
    //       this.newMessage[key] = true
    //     }
    //   }
    //   document.getElementById('firstInput').focus()
    // },

    toggleActive: function (index) {
      this.messages[index].active = !this.messages[index].active
      this.updateNoOfDays()
    },
    uploadModal () {
      if (!this.shift || !this.applicants || !this.branch || !this.department || !this.profession || !this.qualification || !this.specialisation || !this.experience || !this.startDate || !this.endDate || !this.shift || !this.applicants || !this.maxRate) {
        showErrorToast(this, 'All feilds required')
      } else if (this.maxRate < this.minJobRate) {
        showErrorToast(this, `Minimum Rate for the shift is ₹${this.minJobRate} per hour`)
      } else {
        this.modalActive = true
        document.body.classList.add('overlay-bg')
      }
    },
    async close (bool, state) {
      if (!bool) this.modalActive = !this.modalActive
      else this.modalActive = null
      document.body.classList.remove('overlay-bg')

      if (state) {
        var days = []
        this.messages.forEach(element => {
          if (element.active) {
            days.push(element.value)
          }
        })
        const jobType = this.nonConsecutive ? 'NON_CONSECUTIVE' : 'CONSECUTIVE'
        console.log(this.filteredUser)
        const response = await UserService.postMiniJob(this.branch, this.department, this.profession, this.qualification, this.specialisation, this.experience, this.applicants, this.maxRate, this.JD, this.startDate, this.endDate, this.shift, days, jobType, this.checkbox1, this.checkbox2, this.checkbox3, this.filteredUser[0].email, this.filteredUser[0].contact)
        if (!response) {
          showErrorToast(this, 'Job not posted')
        } else {
          showSuccessToast(this, 'Job posted Successfully')
          this.$router.push('/open_jobs')
        }
      }
    },
    // async professionSelected () {
    //   this.qualification = ''
    //   this.specialisation = ''
    //   this.qualifications = await GuestService.listQualificationsType(this.profession)
    //   this.specialisations = await GuestService.listNurseType(this.profession)
    //   this.updateMinJobRate()
    // },
    // Selection updation of drop downs
    async branchSelected () {
      this.department = ''
      this.profession = ''
      this.qualification = ''
      this.specialisation = ''
      this.experience = ''
      this.shift = ''
      this.departments = await UserService.listMiniJobDepartments(this.branch)
      this.updateMinJobRate()
    },
    async departmentSelected () {
      this.profession = ''
      this.qualification = ''
      this.specialisation = ''
      this.experience = ''
      this.shift = ''
      this.professions = await UserService.listMiniJobProfessions(this.branch, this.department)
      this.updateMinJobRate()
    },
    async professionSelected () {
      this.qualification = ''
      this.specialisation = ''
      this.experience = ''
      this.shift = ''
      this.qualifications = await UserService.listMiniJobQualifications(this.branch, this.department, this.profession)
      this.shifts = await UserService.listMiniJobShifts(this.branch, this.profession)
      this.updateMinJobRate()
    },
    async qualificationSelected () {
      this.specialisation = ''
      this.experience = ''
      this.specialisations = await UserService.listMiniJobSpecializations(this.branch, this.department, this.profession, this.qualification)
      this.updateMinJobRate()
    },
    async specialisationSelected () {
      this.experience = ''
      this.experiences = await UserService.listMiniJobExperiences(this.branch, this.department, this.profession, this.qualification, this.specialisation)
      this.updateMinJobRate()
    },
    // Update no. of dates
    updateNoOfDays (startDateUpdated = false) {
      // if (this.startDate > this.endDate) {
      //   showErrorToast(this, 'Start Date should be greater than end time')
      // }
      if (startDateUpdated) {
        this.endDate = ''
        this.days = 'Fill above fields'
      }
      if (this.messages.filter(item => item.active).length) {
        const weekdays = this.messages.filter(item => item.active).map(item => item.day)
        const startDate = new Date(this.startDate + ' UTC +05:30')
        const endDate = new Date(this.endDate + ' UTC 05:30')
        const days = Math.round((endDate.getTime() - startDate.getTime()) / (24 * 60 * 60 * 1000))
        let dates = Array.from({ length: days + 1 }).map((item, index) => {
          if (index > 0) startDate.setDate(startDate.getDate() + 1)
          return startDate.toISOString()
        })
        if (weekdays.length > 0) {
          dates = dates.filter(item => {
            const date = new Date(item)
            return weekdays.includes(date.getDay())
          })
        }
        this.days = dates.length
      } else if (this.startDate && this.endDate) {
        const startDate = new Date(this.startDate + ' UTC +05:30')
        const endDate = new Date(this.endDate + ' UTC 05:30')
        this.days = Math.ceil((endDate.getTime() - startDate.getTime()) / (24 * 60 * 60 * 1000))
      }
      this.updateMinJobRate()
    },
    // Update min job rate
    async updateMinJobRate () {
      if (this.branch && this.department && this.profession && this.qualification && this.specialisation && this.experience) {
        this.minJobRate = await UserService.getMinJobRate(this.branch, this.department, this.profession, this.qualification, this.specialisation, this.experience)
        this.minJobRate = this.minJobRate ? this.minJobRate : 'Fill above fields'
        await this.updateRateCard()
      } else {
        this.minJobRate = 'Fill above fields'
      }
      this.updateRateCard()
    },
    async updateRateCard () {
      if (this.maxRate && this.applicants && this.days && this.shift) {
        const response = await UserService.getMiniJobCost(this.branch, this.department, this.profession, this.qualification, this.specialisation, this.experience, this.maxRate, this.applicants, this.days, this.shift)
        if (response) {
          this.shiftCost = response.shift
          this.totalCost = response.hospital
          this.marginCost = response.margin
          this.tax = response.gst
          this.total = response.total
          this.totalCostNurse = response.nurse
        } else {
          this.shiftCost = '?'
          this.totalCost = '?'
          this.marginCost = '?'
          this.tax = '?'
          this.total = '?'
          this.totalCostNurse = '?'
        }
      } else {
        this.resetRateCard()
      }
    },
    resetRateCard () {
      this.shiftCost = '?'
      this.totalCost = '?'
      this.marginCost = '?'
      this.tax = '?'
      this.total = '?'
      this.totalCostNurse = '?'
    },
    onChange (e) {
      // console.log('call', e.target.value)
      this.filteredUser = this.orgUsers.filter(user => {
        return user.id === e.target.value
      })
      // console.log(this.filteredUser)
    }
  }
}
